import { inject, provideAppInitializer } from '@angular/core';
import { CoralogixConfig } from '../types';
import { CORALOGIX_CONFIG } from '../tokens/coralogix-config.token';
import { CoralogixService } from '../services/coralogix.service';

export const CORALOGIX_ANONYMOUS_INITIALIZER = provideAppInitializer(() => {
  const initializerFn = ((config: CoralogixConfig, coralogixService: CoralogixService) => () => {
    coralogixService.initialise(config);
  })(inject(CORALOGIX_CONFIG), inject(CoralogixService));
  return initializerFn();
});
